// import { createSlice } from '@reduxjs/toolkit'
// import moment from 'moment';
// import { filterByIncludes, getDateRange } from '../../Helpers/helpers';

// const initialState = {
//     downTimeDate: moment(new Date()).format('YYYY-MM-DD'),
//     lineOpRange: {
//         start: moment(getDateRange(moment(new Date()).format('YYYY-MM-DD'), 'yesterday').start).format('YYYY-MM-DD'),
//         end: moment(getDateRange(moment(new Date()).format('YYYY-MM-DD'), 'yesterday').end).format('YYYY-MM-DD')
//     },
//     logs: null,
//     downtimes: null,
// }

// export const logsSlice = createSlice({
//     name: 'logs',
//     initialState,
//     reducers: {
//         setMergeList: (state, { payload }) => {
//             let { mergeList } = payload;
//             state.mergeList = mergeList
//         },
//         setDowntimeLogs: (state, { payload }) => {
//             let { downtimes } = payload;
//             state.downtimes = downtimes
//         },
//         setLogs: (state, { payload }) => {
//             let { disconnect, downtimes } = payload;
//             let logs = [...disconnect, ...downtimes]
//             state.list = logs
//         },
//         changeDowntimeDate: (state, { payload }) => {
//             let { selectedDate } = payload;
//             state.downTimeDate = selectedDate
//         },
//         changeLineRange: (state, { payload }) => {
//             let { start, end } = payload;
//             state.lineOpRange = payload
//         }
//     },
// })

// // Action creators are generated for each case reducer function
// export const { setMergeList, setDowntimeLogs, changeDowntimeDate, setLogs, changeLineRange } = logsSlice.actions
// export default logsSlice.reducer


import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment';
import { filterByIncludes } from '../../Helpers/helpers';


const getDateRange = (today = new Date(), type = 'yesterday') => {
    let start, end;
    if (type == 'yesterday') {
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)
        end = `${moment(today).format('YYYY-MM-DD')}T02:00:00.000Z`
        start = `${moment(yesterday).format('YYYY-MM-DD')}T01:59:00.000Z`
        return { start, end }
    }
    if (type == 'tomorrow') {
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)
        end = `${moment(today).format('YYYY-MM-DD')}T02:00:00.000Z`
        start = `${moment(tomorrow).format('YYYY-MM-DD')}T01:59:00.000Z`
        return { start, end }
    }

}

const initialState = {
    downTimeDate: moment(new Date()).format('YYYY-MM-DD'),
    lineOpRange: {
        start: moment(getDateRange(moment(new Date()).format('YYYY-MM-DD'), 'yesterday').start).format('YYYY-MM-DD'),
        end: moment(getDateRange(moment(new Date()).format('YYYY-MM-DD'), 'yesterday').end).format('YYYY-MM-DD')
    },
    logs: null,
    downtimes: null,
}

export const logsSlice = createSlice({
    name: 'logs',
    initialState,
    reducers: {
        setMergeList: (state, { payload }) => {
            let { mergeList } = payload;
            state.mergeList = mergeList
        },
        setDowntimeLogs: (state, { payload }) => {
            let { downtimes } = payload;
            let updatedDowntimes = [];
            {
                downtimes.forEach(data => {
                    if(data.reason !== 'Performance Downtime')
                    updatedDowntimes.push(data);
                });
                updatedDowntimes = updatedDowntimes
                ?.map((downtime, index) => {
                    return {
                        ...downtime,
                        key: index + 1,
                    }
                }) 
            }
            //downtimes = downtimes?.filter(data => data.reason !== 'Performance Downtime')
            state.downtimes = updatedDowntimes;
        },
        setLogs: (state, { payload }) => {
            let { disconnect, downtimes } = payload;
            //disconnect = disconnect?.map(disconnect1 =>{
              //  return {...disconnect1,
               // reason:'Disconnect'}
            //})
            let logs = [...disconnect, ...downtimes]
            let updatedLogs = [];
            logs.forEach(data=>{
                if(data.reason !== 'Performance Downtime')
                updatedLogs.push(data);
            })
            updatedLogs = updatedLogs
            ?.map((downtime, index) => {
                return {
                    ...downtime,
                    key: index + 1,
                }
            })
            logs = logs?.filter(data => data.reason !== 'Performance Downtime')
            logs = logs?.sort((a, b) =>  a.startedAt.localeCompare(b.startedAt))
            state.list = updatedLogs
        },
        changeDowntimeDate: (state, { payload }) => {
            let { selectedDate } = payload;
            state.downTimeDate = selectedDate
        },
        changeLineRange: (state, { payload }) => {
            let { start, end } = payload;
            state.lineOpRange = payload
        }
    },
})

// Action creators are generated for each case reducer function
export const { setMergeList, setDowntimeLogs, changeDowntimeDate, setLogs, changeLineRange } = logsSlice.actions
export default logsSlice.reducer
